export const SET_MASTER_OBJECT_TYPE_ID_LOOKUP_VALUES = 'SET_MASTER_OBJECT_TYPE_ID_LOOKUP_VALUES';
export const ADD_ADVANCED_VALUE = 'ADD_ADVANCED_VALUE';
